var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCluster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#008CFF;}\n\t.st1{fill:none;stroke:#008CFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{opacity:0.1;fill:#008CFF;}\n\t.st3{opacity:0.3;fill:#008CFF;}\n\t.st4{opacity:0.5;fill:#008CFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 16,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16,2c4,0,7.5,1.7,10.1,4.3l1.4-1.5C24.5,1.9,20.5,0,16,0C11.6,0,7.6,1.8,4.7,4.7l1.4,1.4C8.6,3.6,12.1,2,16,2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.4,7C23,4.6,19.7,3,16,3c-3.6,0-6.8,1.5-9.2,3.8l1.4,1.4C10.2,6.2,13,5,16,5c3.2,0,6,1.3,8,3.5L25.4,7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8.9,8.9l1.4,1.4C11.8,8.9,13.8,8,16,8c2.4,0,4.5,1,6,2.7l1.4-1.5C21.5,7.2,18.9,6,16,6 C13.2,6,10.7,7.1,8.9,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.6,12.4L29.7,13c0.2,1,0.3,2,0.3,3c0,6.4-4.4,11.9-10.3,13.5l0.5,1.9C27,29.6,32,23.4,32,16 C32,14.8,31.8,13.6,31.6,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2,16c0-1.1,0.2-2.2,0.4-3.3l-1.9-0.6C0.2,13.4,0,14.7,0,16c0,7.4,5,13.6,11.8,15.4l0.5-1.9 C6.4,27.9,2,22.4,2,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29,16c0-0.9-0.1-1.9-0.3-2.7l-1.9,0.6c0.1,0.7,0.2,1.4,0.2,2.2c0,5-3.4,9.3-8,10.6l0.5,1.9 C24.9,27,29,22,29,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5,16c0-0.8,0.1-1.7,0.3-2.4L3.4,13C3.1,14,3,15,3,16c0,6,4.1,11,9.6,12.5l0.5-1.9C8.4,25.3,5,21,5,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26,16c0-0.6-0.1-1.3-0.2-1.9l-1.9,0.6C24,15.1,24,15.6,24,16c0,3.6-2.4,6.7-5.7,7.7l0.5,1.9 C22.9,24.4,26,20.6,26,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8,16c0-0.5,0.1-1.1,0.2-1.6l-1.9-0.6C6.1,14.5,6,15.3,6,16c0,4.6,3.1,8.4,7.3,9.6l0.5-1.9 C10.4,22.7,8,19.6,8,16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCluster);
export default __webpack_public_path__ + "static/media/cluster.01e63dcc063e6432ec24651e532c0a81.svg";
export { ForwardRef as ReactComponent };